import { Place_$ctor_Z721C83C5, Age_$ctor_Z721C83C5, Sex_$ctor_Z721C83C5, Tid_$ctor_Z721C83C5 } from "../Shared/MetadataCategories.js";
import { Metadata_MenuItem } from "../../../../Shared/Shared.js";
import { ofArray } from "../../../../fable_modules/fable-library.3.7.9/List.js";
import { Corpus_$ctor_64685318 } from "../../../../fs/Model/Model.js";

export const metadataMenu = ofArray([new Metadata_MenuItem(0, Tid_$ctor_Z721C83C5("Informant code")), new Metadata_MenuItem(0, Sex_$ctor_Z721C83C5("Gender")), new Metadata_MenuItem(0, Age_$ctor_Z721C83C5("Age")), new Metadata_MenuItem(0, Place_$ctor_Z721C83C5("Place"))]);

export const metadataSelectionTable = ofArray([Tid_$ctor_Z721C83C5("Informant code"), Sex_$ctor_Z721C83C5("Gender"), Age_$ctor_Z721C83C5("Age"), Place_$ctor_Z721C83C5("Place")]);

export const metadataQuickView = ofArray([Tid_$ctor_Z721C83C5("Informant code"), Sex_$ctor_Z721C83C5("Gender"), Age_$ctor_Z721C83C5("Age"), Place_$ctor_Z721C83C5("Place")]);

export const metadataDistributionCategories = ofArray([Tid_$ctor_Z721C83C5("Informant code"), Sex_$ctor_Z721C83C5("Gender"), Age_$ctor_Z721C83C5("Age"), Place_$ctor_Z721C83C5("Place")]);

export function getCorpus(config) {
    return Corpus_$ctor_64685318(config, void 0, metadataMenu, metadataSelectionTable, metadataQuickView, metadataDistributionCategories);
}

